export default {
  unhandledError: 'Unhandled Error' // TODO Localization
};
